import { FormControl, FormHelperText } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import { KTextFieldProps } from 'components/core/KTextField'
import { isEmpty } from 'lodash'
import { FC, forwardRef } from 'react'
import { KFieldLabel } from './KFieldLabel'

type KDatePickerProps = DatePickerProps<moment.Moment> &
  React.RefAttributes<HTMLDivElement> &
  Pick<
    KTextFieldProps,
    'labelSize' | 'label' | 'required' | 'fullWidth' | 'helperText' | 'error'
  >

export const KDatePicker: FC<KDatePickerProps> = forwardRef((props, ref) => {
  const { label, labelSize, required, helperText, disabled, sx, ...restProps } =
    props
  const theme = useTheme()

  return (
    <FormControl
      sx={{
        ...sx,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
      disabled={disabled}
      fullWidth={props.fullWidth}
      ref={ref}
    >
      <KFieldLabel
        labelSize={labelSize}
        sx={{
          marginBottom: 1,
          [theme.breakpoints.down('sm')]: {
            marginBottom: 0.5,
          },
        }}
        required={required}
      >
        {label}
      </KFieldLabel>
      <DatePicker
        {...(restProps as any)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 4,
            height: 56,
            '&:hover': {
              backgroundColor: theme.palette.grey['A100'],
            },
            [theme.breakpoints.down('sm')]: {
              borderRadius: 3.5,
              height: 52,
            },
          },
        }}
      />
      {!isEmpty(helperText) && (
        <FormHelperText
          error={props.error}
          sx={{ fontSize: theme.typography.subtitle1.fontSize }}
        >
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
})
